import { observer } from 'mobx-react-lite';
import posthog from 'posthog-js';
import type { JSX } from 'react';
import React, { useEffect } from 'react';

import type { Campaign, IConfig, TStatsChannelKey } from '@feathr/blackbox';
import { CampaignLabelMap } from '@feathr/blackbox';
import ReportWrapper from '@feathr/extender/components/ReportWrapper';
import { type IUseReportExportReturn } from '@feathr/extender/hooks';
import { useAccount } from '@feathr/extender/state';
import { logUserEvents } from '@feathr/hooks';
import { CampaignReport, ReportProvider } from '@feathr/report_components';

interface IProps extends IUseReportExportReturn<IConfig> {
  activeChannel?: TStatsChannelKey;
  campaign: Campaign;
  hideReachBreakdown?: boolean;
}

function CampaignReportSection({
  activeChannel,
  campaign,
  hideReachBreakdown,
  ...reportExportProps
}: Readonly<IProps>): JSX.Element {
  const account = useAccount();

  useEffect(() => {
    logUserEvents({
      [`Viewed ${CampaignLabelMap.get(campaign.get('_cls'))} report`]: {
        account_id: account.id,
        campaign_id: campaign.id,
      },
    });
    posthog.capture('campaign_report_viewed', {
      campaign_id: campaign.id,
      campaign_type: campaign.get('_cls'),
      account_id: account.id,
    });
  }, []);
  return (
    <ReportProvider>
      <ReportWrapper
        activeChannel={activeChannel}
        hideCustomDateRange={campaign.isEmail}
        hideReachBreakdown={hideReachBreakdown}
        model={campaign}
        Report={CampaignReport}
        showVerifiedActivityToggle={campaign.isEmail && campaign.get('show_bot_toggle')}
        {...reportExportProps}
      />
    </ReportProvider>
  );
}

export default observer(CampaignReportSection);
